<template>
  <div class="bcc-nav-slider-sub-menu__wrap">
   <div
    class="bcc-nav-slider-sub-menu"
    :class="{'is-active': active}"
    @click.stop="clickHead">
      <slot name="title">
        <bcc-icon :type="preIcon"></bcc-icon>
        <span class="text">{{text}}</span>
        <bcc-icon :type="endIcon"></bcc-icon>
      </slot>
    </div>
     <bcc-collapse-transition>
      <div v-show="showGroup" class="bcc-nav-slider-sub-menu__group">
            <slot name="group"></slot>
      </div>
    </bcc-collapse-transition>
  </div>
</template>
<script>
import BccIcon from '../../icon'
import BccCollapseTransition from '../../../transitions/collapse-transition.js'
import mixin from './mixin.js'

export default {
  name: 'BccNavSliderSubMenu',
  components: {
    BccCollapseTransition,
    BccIcon
  },
  mixins: [mixin],
  data () {
    return {
      showGroup: false,
      groups: {}
    }
  },
  props: {
    index: {
      required: true,
      default: ''
    },
    preIcon: {
      type: String,
      default () {
        return ''
      }
    },
    text: {
      type: String,
      default () {
        return ''
      }
    },
    endIcon: {
      type: String,
      default () {
        return ''
      }
    }
  },
  watch: {
    showGroup (val) {
      this.rootMenu.$emit('groupStatus')
    }
  },
  computed: {
    active () {
      return this.index === this.rootMenu.activeIndex
    }
  },
  mounted () {
    this.rootMenu.addItem(this)
    this.$on('setGroup', this.setGroup)
  },
  methods: {
    clickHead () {
      this.rootMenu.$emit('item-click', this)
      this.$emit('item-click', this.index)
      if (this.rootMenu.expandOnly) {
        this.closeOtherGroup()
      }
      this.showGroup = !this.showGroup
    },
    closeOtherGroup () {
      let items = this.rootMenu.items
      for (let key in items) {
        if (key !== this.index) {
          items[key].$emit('setGroup', false)
        }
      }
    },
    setGroup (showGroup) {
      this.showGroup = showGroup
    }
  }
}
</script>
